import { CheckIcon } from "@/icons/widget-menu";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./StickerColorMenu.module.css";

interface StickerColorMenuButtonProps {
    color: string;
    selectedColors: string[];
    onColorClick: (color: string) => void;
}

export function StickerColorMenuButton({
    color,
    selectedColors,
    onColorClick,
}: StickerColorMenuButtonProps) {
    const handleClick = () => {
        onColorClick(color);
    };

    const [firstColor, secondColor] = selectedColors;
    const isSelectedColor = color === firstColor || color === secondColor;

    return (
        <MenuButton onClick={handleClick}>
            <div className={styles.item} style={{ background: color }} />
            {isSelectedColor && <CheckIcon className={styles.icon} />}
        </MenuButton>
    );
}
